import { useState, useEffect } from "react";
import { Clock } from "lucide-react";
import { useCart } from "../contexts/CartContext";

const CART_TIMEOUT_MINUTES = 15;

export default function CartTimer() {
  const { cartTimerStart, cartCount, clearCart } = useCart();
  const [remaining, setRemaining] = useState(null);

  useEffect(() => {
    if (!cartTimerStart || cartCount === 0) {
      setRemaining(null);
      return;
    }

    const update = () => {
      const start = new Date(cartTimerStart).getTime();
      const expiry = start + CART_TIMEOUT_MINUTES * 60 * 1000;
      const now = Date.now();
      const diff = expiry - now;

      if (diff <= 0) {
        clearCart();
        setRemaining(null);
        return;
      }
      setRemaining(diff);
    };

    update();
    const interval = setInterval(update, 1000);
    return () => clearInterval(interval);
  }, [cartTimerStart, cartCount, clearCart]);

  if (!remaining || remaining <= 0 || cartCount === 0) return null;

  const mins = Math.floor(remaining / 60000);
  const secs = Math.floor((remaining % 60000) / 1000);
  const isUrgent = remaining < 120000;

  return (
    <div
      className={`flex items-center gap-2 px-3 py-1.5 text-[11px] tracking-wide ${
        isUrgent ? "bg-red-50 text-red-600" : "bg-[#F5F0E6] text-[#9A7B4F]"
      }`}
      data-testid="cart-timer"
    >
      <Clock className="w-3.5 h-3.5" strokeWidth={1.5} />
      <span className="font-medium">
        {String(mins).padStart(2, "0")}:{String(secs).padStart(2, "0")}
      </span>
      <span className="opacity-70">to complete checkout</span>
    </div>
  );
}
